import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Auth from './pages/Auth'
import RequireAuth from './components/RequireAuth'
import Layout from './components/Layout/Layout'
import Home from './pages/Dashboard/Home/Home'
import Uploads from './pages/Dashboard/Uploads/Uploads'
import ModalHost from './components/ModalHost'
import { LoginForm } from './pages/Auth/LoginForm'
import React from 'react'
import ThemeProvider from './context/ThemeProvider'
import { SignUpPage } from './pages/Auth/Signup'
import { UserProfilePage } from './pages/Dashboard/User/Profile'
import { ForgotPasswordCard } from './pages/Auth/ForgotPassword'
import DateRangeProvider from './context/DateRangeProvider'
import Landing from './pages/Landing'
import FAQPage from './pages/FAQ'
import PrivacyPolicyPage from './pages/PrivacyPolicy'

function App(): JSX.Element {
  return (
    <>
      <ThemeProvider>
        <DateRangeProvider>
          <ModalHost>
            <Toaster />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/auth/*" element={<Auth />}>
                  <Route path={'login'} element={<LoginForm />} />
                  <Route path={'signup'} element={<SignUpPage />} />
                  <Route path={'forgot-password'} element={<ForgotPasswordCard />} />
                  <Route path={'*'} element={<Navigate to={'login'} />} />

                  {/* <Route path={'google/*'} element={<GoogleCallback />} /> */}
                </Route>
                <Route
                  path="/dashboard/*"
                  element={
                    <RequireAuth>
                      <Layout />
                    </RequireAuth>
                  }>
                  <Route path="home/*" element={<Home />} />
                  <Route path="uploads/*" element={<Uploads />} />
                  <Route path="profile" element={<UserProfilePage />} />
                  <Route path="*" element={<Navigate to={'home'} replace />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </ModalHost>
        </DateRangeProvider>
      </ThemeProvider>
    </>
  )
}

export default App
